import {Injectable} from '@angular/core';
import {ApiService} from "@core/shared/services/api.service";
import {HttpClient, HttpHeaders} from "@angular/common/http";
import {Observable} from "rxjs";
import {Pagination} from "@core/shared/models/pagination";
import {SocietyGroup} from "@core/shared/models/society-group";
import {AllPaginateItemsAPI} from "@core/shared/models/all-paginate-items-api";

@Injectable({
    providedIn: 'root'
})
export class SocietyGroupService {

    constructor(
        private _apiService: ApiService,
        private _httpClient: HttpClient
    ) {}

    public getPaginationItemsAPI(params?: string[]): Observable<Pagination<SocietyGroup>> {

        const headers: HttpHeaders = new HttpHeaders()
            .set('Content-Type', 'application/json')
            .set('Accept', 'application/json');

        let url: string = `${this._apiService.getApiUrl(false, true)}/societies/groups`;

        params = params || [];

        if (params.length > 0) {

            url = `${url}?${params.join('&')}`;
        }

        return this._httpClient.get<Pagination<SocietyGroup>>(url, {
            headers: headers
        });
    }

    public getItemsAPI(params?: string[]): Observable<SocietyGroup[]> {

        return new AllPaginateItemsAPI<SocietyGroup>(this.getPaginationItemsAPI.bind(this), params).request$;
    }

    public getItemAPI(id: number, params?: string[]): Observable<SocietyGroup> {

        const headers: HttpHeaders = new HttpHeaders()
            .set('Content-Type', 'application/json')
            .set('Accept', 'application/json');

        let url: string = `${this._apiService.getApiUrl(false, true)}/societies/groups/${id}`;

        if(!!params && params.length > 0){

            url = `${url}?${params}`;
        }

        return this._httpClient.get<SocietyGroup>(url,{
            headers: headers
        });
    }

    public createItemAPI(data: object): Observable<SocietyGroup> {

        const headers: HttpHeaders = new HttpHeaders()
            .set('Content-Type', 'application/json')
            .set('Accept', 'application/json');

        return this._httpClient.post<SocietyGroup>(`${this._apiService.getApiUrl(false, true)}/societies/groups`, data, {
            headers: headers
        });
    }

    public updateItemAPI(id: number, data: object): Observable<SocietyGroup> {

        const headers: HttpHeaders = new HttpHeaders()
            .set('Content-Type', 'application/json')
            .set('Accept', 'application/json');

        return this._httpClient.patch<SocietyGroup>(`${this._apiService.getApiUrl(false, true)}/societies/groups/${id}`, data, {
            headers: headers
        });
    }

    public deleteItemAPI(id: number): Observable<void> {

        const headers: HttpHeaders = new HttpHeaders()
            .set('Content-Type', 'application/json')
            .set('Accept', 'application/json');

        return this._httpClient.delete<void>(`${this._apiService.getApiUrl(false, true)}/societies/groups/${id}`,{
            headers: headers
        });
    }
}
